import { createContext, useState, useContext, ReactNode } from 'react'
import { useMediaQuery } from 'react-responsive'

interface SidebarContextType {
  isExpanded: boolean
  toggleSidebar: () => void
  openSidebar: () => void
  closeSidebar: () => void
}

interface SidebarProviderProps {
  children: ReactNode
}

const DRAWER_STATE_KEY = 'drawerMenuState'

const SidebarContext = createContext<SidebarContextType>({
  isExpanded: false,
  toggleSidebar: () => {},
  openSidebar: () => {},
  closeSidebar: () => {}
})

export const SidebarProvider = ({ children }: SidebarProviderProps) => {
  const isMobile = useMediaQuery({ maxWidth: 480 })
  const cookieDrawerState = JSON.parse(localStorage.getItem(DRAWER_STATE_KEY) || 'true')
  const [isExpanded, setIsExpanded] = useState(isMobile ? false : cookieDrawerState)

  const handleStateChange = (newState: boolean) => {
    setIsExpanded(() => {
      localStorage.setItem(DRAWER_STATE_KEY, JSON.stringify(newState))
      return newState
    })
  }

  const toggleSidebar = () => handleStateChange(!isExpanded)
  const openSidebar = () => handleStateChange(true)
  const closeSidebar = () => handleStateChange(false)

  return (
    <SidebarContext.Provider value={{ isExpanded, toggleSidebar, openSidebar, closeSidebar }}>
      {children}
    </SidebarContext.Provider>
  )
}

export const useSidebarContext = () => useContext(SidebarContext)
